import React, { useEffect, useState, useMemo } from 'react';
import ModuleDetail from './ModuleDetail';
import { Globe } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * WebsiteModulePage — toont de Website-module met dynamische scan-data.
 *
 * Belangrijk: geen hardcoded €19,95 placeholder problemen meer. We tonen
 * uitsluitend wat de scan voor déze klant heeft gevonden. Als er geen scan
 * is, krijgen we een nette empty state (afgehandeld door ModuleDetail).
 */
export default function WebsiteModulePage() {
  const { api } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    api('get', '/api/platform/dashboard').then(r => setData(r.data)).catch(console.error);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const { problems, solutions } = useMemo(() => {
    const opdrachten = data?.opdrachten || [];
    // Filter alleen website-gerelateerde categorieën
    const websiteCats = new Set(['website', 'seo', 'on_page', 'meta', 'content']);
    const filtered = opdrachten.filter(o => websiteCats.has((o.category || '').toLowerCase()));

    const probs = filtered.map(o => ({
      title: o.title || 'Verbeterpunt',
      priority: o.priority === 'high' ? 'hoog' : o.priority === 'medium' ? 'middel' : 'laag',
      desc: o.description || o.probleem || '',
      impact: o.impact || o.waarom_beter || '',
      huidige_situatie: o.huidige_situatie,
      beter_voorstel: o.beter_voorstel,
      pagina: o.pagina,
      execution_mode: o.execution_mode || o.actie_type,
      // Geen hardcoded service prijs meer — alleen tonen als de scan zelf een dienst suggereert
      service: o.service_suggestion || null,
    }));

    const sols = filtered.slice(0, 6).map(o => ({
      title: o.beter_voorstel || o.title || 'Aanbeveling',
      desc: o.waarom_beter || o.description || '',
    }));

    return { problems: probs, solutions: sols };
  }, [data]);

  const mods = data?.scan?.analyse?.module_scores || {};
  const ws = mods.website || {};

  return (
    <ModuleDetail
      title="Website Analyse"
      subtitle="Technische kwaliteit, laadsnelheid, mobiele optimalisatie en SEO-basis — op basis van uw eigen scan"
      icon={Globe} color="#3b82f6"
      score={ws.score || data?.scan?.analyse?.overall_score || 0}
      analyse={data?.scan?.analyse}
      problems={problems}
      solutions={solutions}
      services={[]} /* Geen hardcoded à-la-carte services — ModuleDetail toont managed-banner of niets */
    />
  );
}
